<template>
    <div class="row mt-5">
        <div class="col-md-4 spark-settings-tabs">
            <aside v-if="selectedReport.id === 'computerEase-customers'">
                <h3 class="nav-heading">
                    Costumers
                </h3>
                <div class="rounded w-full px-2 text-grey-darker">
                    <div class="flex text-center mb-3">
                        <button class="btn-link mr-3" for="all" @click="selectAll">Select all </button>
                        <button class="btn-link" for="none" @click="selectedCustomers = [], selectedJobs = []">Clear all  </button>
                    </div>
                    <div  class="text-justify overflow-y-auto" style="max-height: 60vh">
                        <div v-for="customer of customers" :key="customer.id">
                            <input type="checkbox" name="master-customers-list" :value="customer.id" v-model="selectedCustomers">
                            <label :for="customer.name">{{customer.name}}</label>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
        <div class="col-md-8">
            <div class="pull-right">
                <button
                    class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                    @click="generateReport" type="button">
                    Export to Zip
                </button>
            </div>
            <div id="master-customer-reports" >
                <div class="rounded w-full px-2 text-grey-darker text-justify">
                     <h3 class="nav-heading ">
                        Reports / Exports
                    </h3>
                    <div v-for="report of reports" :key="report.id">
                        <input type="radio" name="to_generate" :value="getValue(report)" v-model="selectedReport">
                        <label :for="report.name">{{report.name}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Mixin from './mixin';
import Form from "../../utils/form";
import Multiselect from "vue-multiselect";

export default {
    mixins: [Mixin],

    name: 'computerEase-report',

    props: ['filter-uri', 'userRole', 'team'],
    components: {Multiselect},
    data() {
        return {
            customers: [],
            selectedCustomers: [],
            selectedJobs: [],
            selectedReport: [],
            reports: [
                // { id: 'computerEase-customers', name: 'Customers', excel: true },
                { id: 'computerEase-jobs', name: 'Projects', excel:true },
            ],
            options: [],
        }
    },
    created(){
        this.getCustomers();
    },

    watch:{
        selectedReport(val){
            this.$emit('change-report', val.id);
        },
    },

    methods: {
        getValue(report){
            return {
                id: report.id,
                name: report.name,
                excel: report.excel,
                pdf: report.pdf ?? null
            }
        },
        getCustomers(){
            axios.get(route('api.company.list-for-report')).then((response) => {
                this.customers = response.data;
            });
        },
        generateReport() {
            if(this.selectedReport && this.selectedCustomers || this.selectedJobs)  {
                let path = '';

                let uri = this.filterUri.substr(0, this.filterUri.length);
                uri += '&name=' + this.selectedReport.name;

                path += "/reports-charts/" + this.selectedReport.id + uri + '&xml=true';


                console.log("path", path);
                if (this.checkValidations(path)){
                    return;
                }

                let self = this;
                axios.get(path).then(response => {
                    path += '&is_computerEase_tab=true'
                    this.createPop(path, this.selectedReport);
                }).catch(error => {
                    path += '&is_computerEase_tab=true'
                    this.createPop(path, this.selectedReport);
                    // if(error){
                    //     self.getToast().fire({
                    //         title: "Message",
                    //         text: "This is not a bug! You just don't have access to this record. Ask your administrator for more details.",
                    //         confirmButtonColor: 'red',
                    //         dangerMode: true,
                    //     });
                    // }
                });
            }
        },
        selectAll(){
            let self = this;

            if (this.selectedReport.id === 'computerEase-customers') {
                self.selectedCustomers = [];
                this.customers.forEach(customer => self.selectedCustomers.push(customer.id));
            } else if (this.selectedReport.id === 'computerEase-jobs') {
                self.selectedJobs = [];
                this.jobs.forEach(customer => self.selectedJobs.push(customer.id));
            }
        }
    }
  };
</script>
